import { IEdiMessage, Maybe } from 'types/graphqlTypes'
import { useConfigurableBuilderVersionsQuery } from '../../EdiSelfServiceOutbound/graphql/ConfigurableBuilderVersions'

export const useGetLiveBuilderVersion = (
  ediMessageType: Maybe<IEdiMessage>,
  builderId: Maybe<string>
) => {
  const configurableBuilderId = builderId || ediMessageType?.ediMapperConfigurableBuilderId
  const { data: versionsData } = useConfigurableBuilderVersionsQuery({
    variables: {
      id: configurableBuilderId || '',
    },
    skip: !configurableBuilderId,
  })
  const liveVersion = versionsData?.configurableBuilderVersions?.filter(
    version => version.isLive === true
  )[0]
  return liveVersion
}
